export const ENDPOINTS = {
  getBookings: '/gateway/extranet/:hotelId/bookings',
  getBooking: '/gateway/extranet/:hotelId/bookings/:bookingCode',
  downloadBookingsCsv: '/gateway/extranet/:hotelId/bookings/csv',
  getCardInfos:
    '/gateway/extranet/:hotelId/bookings/:bookingCode/card-display-key',
} as const;

export const CORE_QUERY_KEYS = {
  bookings: 'extranet-bookings',
  booking: 'extranet-booking',
} as const;
